import React from "react";
import ReporteDocNavasoftScreen from "../componentes/ReporteDocNavasoft/ReporteDocNavasoftScreen";

export default class ReporteDocNavasoftPage extends React.Component {
    constructor (props) {
        super(props);
    }

    render() {
        return (
            <div className="">
                <ReporteDocNavasoftScreen />
            </div>
        )
    }
}